module.exports = __webpack_public_path__ + "img/home-header-poster.cadbb29b.png";